import React from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "../../../assets/aboutUs/about2.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: { display: "flex" },
  text: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    overflow: "hidden",
  },
  title: {
    backgroundColor: palette.secondary.main,
    alignSelf: "start",
    fontWeight: "bold",
    fontSize: "36px",
    color: "#272727",
    marginLeft: "10%",
    paddingLeft: "60px",
    paddingRight: "60px",
  },
  paragraph: {
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "18px",
    color: "#272727",
    width: "30%",
    textAlign: "end",
    marginRight: "5%",
  },
  year: {
    color: "#272727",
    fontWeight: "bold",
    fontSize: "180px",
    marginRight: "5%",
  },
  images: {},
}));

const about2 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Box component="div" className={classes.text}>
        <Typography className={classes.title} variant="h6">
          Historia
        </Typography>
        <Typography p="true" className={classes.paragraph}>
          Manuel Ventura, guatemalteco y originario de Quiché, en 1979, decide
          adquirir 2 máquinas para fabricar veladoras de repuesto, y sin ninguna
          experiencia previa, inicia una empresa en el patio de su residencia en
          la zona 7 capitalina. El nombre de la empresa “Velas Jesús Nazareno”.
          A esa fecha ya manejaba, con su esposa, un negocio de ventas de
          especies que deciden mantener de forma paralela. Empezó a ofrecer sus
          veladoras, de forma minuciosa y constante, vendiendo apenas 2 o 3
          docenas diarias. Este esfuerzo fue abriéndole paso en los comercios de
          velas, que en esa época eran principalmente artesanales. Su nombre
          empezó a ser reconocido en la capital y algunos departamentos.
        </Typography>
        <Typography className={classes.year} variant="h3">
          1979
        </Typography>
      </Box>
      <Box component="div" className={classes.images}>
        <CardMedia className={classes.img} component="img" image={photo} />
      </Box>
    </Box>
  );
};

export default about2;
